// extracted by mini-css-extract-plugin
export default {"tooltip":"tS-z","arrow":"uS-z"};